import MxErrorMessage from "@rf-l1/form/MxErrorMessage";
import { useMxFieldControllerContext } from "../../../context/MxFieldController";
import { useMemo } from "react";

export interface IMxFormErrorMessageProps {}
const MxFormErrorMessage = (props: IMxFormErrorMessageProps) => {
  const { error, name } = useMxFieldControllerContext();

  const errorMessage = useMemo(() => {
    if (typeof error == "undefined") return "";
    if (!error) return "";
    if (error?.message) return error?.message;
    return "";
  }, [error]);
  return <MxErrorMessage error={errorMessage} />;
};

export default MxFormErrorMessage;
